import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { modReferralsReport_template } from "../components/templates/modReferralsReport_template";

declare var ko: any;

export class mod_referrals extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: modReferralsReport_template;
    protected timer;

    protected getModuleName() {

        return "mod_referrals";
    }

    buildContent(): Array<Element> {

        this.elementsList = new modReferralsReport_template("list", this.viewModel, this);
        this.template = this.elementsList;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Mod Referral Report");

        return [this.elementsList.build()];
    }

    public fillPage(): void {

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected listReorder() {

        this.filterList();
    }

    protected paginationOnPageClick() {

        this.filterList();
    }

    protected filterSimpleOnChange() {

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getMemoryViewModel() {

        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.referrals;

        return templateViewModel;
    }

    protected view(data) {

        const idWebsiteUser = data.idWebsiteUser || data.id;
        window.open('/website-users/edit/' + idWebsiteUser, '_blank');
    }

    protected filterList() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        this.timer = new Date().getTime();
        let usrReq_url: string = '/api/mod/referrals/get/';
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'mods');
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.updateViewModelFromPath();
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });

        };
    }

    protected updateList(responseParsed: any) {

        this.elementsList.setReferrals(responseParsed.paginatedResults.data);

        let execTime = Math.round((new Date().getTime() - this.timer) / 1000 * 100) / 100;
        this.elementsList.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage, execTime);

        this.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);
    }

}



// WEBPACK FOOTER //
// ./js/modules/mod_referrals.ts